"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFlagkit = _interopRequireDefault(require("react-flagkit"));
var _OrderStatus = _interopRequireDefault(require("../OrderStatus"));
var _constants = require("../OrderStatus/constants");
var _Name = _interopRequireDefault(require("../../Clients/Name/Name"));
var _excluded = ["countryCode", "region", "details", "onCreateTicket", "status", "orderId", "href", "clientId", "name", "ticketable"];
var OrderSearchCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var countryCode = _ref.countryCode,
    region = _ref.region,
    details = _ref.details,
    onCreateTicket = _ref.onCreateTicket,
    status = _ref.status,
    orderId = _ref.orderId,
    href = _ref.href,
    clientId = _ref.clientId,
    name = _ref.name,
    ticketable = _ref.ticketable,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledOrderSearchCard, props, /*#__PURE__*/_react["default"].createElement(StyledClient, null, clientId && /*#__PURE__*/_react["default"].createElement(StyledIdentifier, {
    title: clientId
  }, clientId), /*#__PURE__*/_react["default"].createElement(StyledName, {
    name: name
  })), /*#__PURE__*/_react["default"].createElement(StyledOrder, null, /*#__PURE__*/_react["default"].createElement(StyledCommon, null, /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
    href: href,
    id: orderId,
    status: status
  }), countryCode && /*#__PURE__*/_react["default"].createElement(StyledCountryFlag, {
    country: countryCode
  }), region && /*#__PURE__*/_react["default"].createElement(StyledRegion, {
    title: region
  }, region), details && /*#__PURE__*/_react["default"].createElement(StyledDetails, {
    title: details
  }, details)), countryCode && /*#__PURE__*/_react["default"].createElement(StyledCountryCode, null, countryCode)));
});
OrderSearchCard.propTypes = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
  // старые типы из компонента OrderStatus (OrderStatusPropTypes)
  // TODO: убрать при переносе на ts
  className: _propTypes["default"].string,
  href: _propTypes["default"].string.isRequired,
  // id: PropTypes.string.isRequired,
  status: _propTypes["default"].oneOf(Object.values(_constants.ORDER_STATUSES)).isRequired,
  onClickId: _propTypes["default"].func,
  suffix: _propTypes["default"].node
}, "className", _propTypes["default"].string), "countryCode", _propTypes["default"].string), "region", _propTypes["default"].string), "details", _propTypes["default"].string.isRequired), "onCreateTicket", _propTypes["default"].func), "clientId", _propTypes["default"].string.isRequired), "orderId", _propTypes["default"].string.isRequired), "name", _propTypes["default"].string), "ticketable", _propTypes["default"].bool);
OrderSearchCard.defaultProps = {
  className: '',
  countryCode: '',
  region: '',
  name: '',
  ticketable: true,
  onCreateTicket: Function.prototype
};
var StyledOrderSearchCard = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledOrderSearchCard",
  componentId: "sc-1sn2rwu-0"
})(["display:flex;flex-wrap:wrap;height:44px;background-color:#fff;"]);
var StyledIdentifier = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledIdentifier",
  componentId: "sc-1sn2rwu-1"
})(["padding-right:9px;font-size:14px;line-height:1.29;letter-spacing:normal;color:#919499;::before{content:'#';}"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "OrderSearchCard__StyledName",
  componentId: "sc-1sn2rwu-2"
})(["white-space:nowrap;display:inline-block;vertical-align:middle;text-overflow:ellipsis;"]);
var StyledOrderStatus = (0, _styledComponents["default"])(_OrderStatus["default"]).withConfig({
  displayName: "OrderSearchCard__StyledOrderStatus",
  componentId: "sc-1sn2rwu-3"
})(["width:190px;height:17px;line-height:18px;overflow:visible;text-align:left;"]);
var StyledOrder = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledOrder",
  componentId: "sc-1sn2rwu-4"
})(["display:flex;width:100%;height:18px;color:#919499;line-height:18px;margin-bottom:5px;"]);
var StyledCountryFlag = (0, _styledComponents["default"])(_reactFlagkit["default"]).withConfig({
  displayName: "OrderSearchCard__StyledCountryFlag",
  componentId: "sc-1sn2rwu-5"
})(["height:100%;margin-left:11px;width:17px;"]);
var StyledClient = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledClient",
  componentId: "sc-1sn2rwu-6"
})(["display:flex;width:100%;height:18px;font-size:14px;margin-top:5px;"]);
var StyledRegion = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledRegion",
  componentId: "sc-1sn2rwu-7"
})(["color:#4d4d4d;height:100%;padding-left:11px;max-width:200px;min-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledDetails = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledDetails",
  componentId: "sc-1sn2rwu-8"
})(["color:#4d4d4d;height:100%;padding-left:11px;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledCommon = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledCommon",
  componentId: "sc-1sn2rwu-9"
})(["display:flex;flex-grow:1;text-align:left;overflow:hidden;white-space:nowrap;"]);
var StyledCountryCode = _styledComponents["default"].div.withConfig({
  displayName: "OrderSearchCard__StyledCountryCode",
  componentId: "sc-1sn2rwu-10"
})(["padding-left:11px;"]);
OrderSearchCard.STATUSES = _constants.ORDER_STATUSES;
var _default = exports["default"] = OrderSearchCard;